import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LANDING_HTML } from "@/landing/landingHtml";
import "@/landing/landing.css";

export default function Landing() {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "KidPath — A calmer path through autism funding & support";
    const root = ref.current;
    if (!root) return;

    // Nav scroll shadow
    const nav = root.querySelector("#nav");
    const onScroll = () => nav && nav.classList.toggle("scrolled", window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    // Mobile menu
    const mb = root.querySelector("#menuBtn");
    const nl = root.querySelector("#navlinks");
    const scrim = root.querySelector("#navscrim");
    const setOpen = (open) => {
      if (nl) nl.classList.toggle("open", open);
      if (scrim) scrim.classList.toggle("open", open);
      if (mb) mb.setAttribute("aria-expanded", open);
      document.body.style.overflow = open ? "hidden" : "";
    };
    const toggle = () => setOpen(!(nl && nl.classList.contains("open")));
    if (mb && nl) mb.addEventListener("click", toggle);
    if (scrim) scrim.addEventListener("click", () => setOpen(false));

    // Intercept internal route links (/, /login, /register)
    const onClick = (e) => {
      const a = e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("/") && !href.startsWith("//")) {
        e.preventDefault();
        navigate(href);
      }
      setOpen(false);
    };
    root.addEventListener("click", onClick);

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (mb) mb.removeEventListener("click", toggle);
      root.removeEventListener("click", onClick);
      document.body.style.overflow = "";
    };
  }, [navigate]);

  return <div ref={ref} className="landing-page" data-testid="landing-page" dangerouslySetInnerHTML={{ __html: LANDING_HTML }} />;
}
